import React from "react";
import styles from "./WhatsAppButton.module.css";
import { useTranslation } from "react-i18next";

const WhatsAppButton: React.FC = () => {
  const { i18n } = useTranslation();
  const isTurkish = i18n.language?.toLowerCase().startsWith("tr");
  const href = isTurkish
    ? "https://wa.me/905016566778"
    : "https://wa.me/77072179227";

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.btn}
      aria-label="WhatsApp"
    >
      <svg
        className={styles.icon}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16 3C9.373 3 4 8.373 4 15c0 2.385.668 4.61 1.832 6.505L4 29l7.695-1.805A11.94 11.94 0 0 0 16 28c6.627 0 12-5.373 12-12S22.627 3 16 3Z"
          fill="#fff"
        />
        <path
          d="M21.386 18.56c-.307-.154-1.816-.895-2.097-.997-.28-.102-.485-.153-.689.154-.204.307-.79.997-.968 1.201-.178.205-.357.23-.664.077-.307-.154-1.296-.478-2.468-1.524-.912-.814-1.527-1.82-1.706-2.127-.178-.307-.019-.473.134-.625.137-.137.307-.357.46-.536.154-.178.205-.307.307-.511.102-.205.051-.384-.026-.537-.077-.154-.689-1.662-.944-2.275-.249-.598-.501-.517-.689-.527l-.587-.01c-.204 0-.536.077-.817.384-.28.307-1.07 1.046-1.07 2.552s1.096 2.96 1.248 3.164c.153.204 2.156 3.292 5.226 4.617.73.315 1.3.503 1.744.644.733.233 1.4.2 1.927.121.588-.088 1.816-.742 2.073-1.46.256-.716.256-1.33.179-1.46-.077-.128-.28-.204-.587-.358Z"
          fill="#25D366"
        />
      </svg>
      <span className={styles.pulse} />
    </a>
  );
};

export default WhatsAppButton;